import Section from "@/components/ui/section";
import React from "react";
import cn from "classnames";
import Image from "next/image";
import Slick from "@/components/ui/carousel/slick";
import Link from "next/link";
export default function Reports() {
  const data = [
    {
      title:
        "Working Without Walls: Climate exposure in food delivery, ridesharing and home services platform sectors in Asia",
      image: "/images/home/reports/Working-without-walls.webp",
      link: "/pdfs/WorkingWithoutWalls.pdf",
    },
    {
      title:
        "Hot Cities Make Hard Work Harder: Strengthening Health and Livelihood Resilience for Informal Workers in South and Southeast Asian Cities",
      image: "/images/home/reports/hot-cities.webp",
      link: "/pdfs/HotCitiesReport.pdf",
    },
    {
      title:
        "Innovative ideas to make workers more resilient during extreme heat",
      image: "/images/home/reports/supplement.webp",
      link: "/pdfs/IdeasForHeatResilience.pdf",
    },
    {
      title:
        "Building Climate Resilience: Evidence from source districts of Jhansi and Palamu",
      image: "/images/home/reports/ICC report thumb.webp",
      link: "/pdfs/Building Climate Resilience.pdf",
    },
    {
      title: "Invisible Control, Visible Risk",
      image: "/images/home/reports/inivisble-control.webp",
      link: "/pdfs/DPW report.pdf",
    },
    {
      title: "Emergency response to heatwave crisis",
      image: "/images/home/reports/Emergency Workbook-2025.webp",
      link: "/pdfs/Emergency response to heat wave crisis in South and Southeast Asia.pdf",
    },
    {
      title: "Informal matters",
      image: "/images/MRC InformalMatters cover final_page-0001.webp",
      link: "/pdfs/PeoplesCourageInternational_InformalMattersReport_18June2025.pdf",
    },
    // {
    //   title: "Insuring Dignity",
    //   image: "/images/empowering-workers.webp",
    //   link: "/pdfs/AQI REPORT-FINAL_2.pdf",
    // },
    {
      title: "Coping with Climate",
      image: "/images/home/reports/coping.webp",
      link: "/pdfs/PCI RESEARCH REPORT FINAL.pdf",
    },
    {
      title: "Voices of Resilience",
      image: "/images/home/reports/voices.webp",
      link: "/pdfs/PCI_Case Study Booklet_Revised Digital_ Final_20092024 (1).pdf",
    },
    {
      title: "Internal Migration in Asia",
      image: "/images/home/reports/Internal-migration-in-Asia-1.jpg",
      link: "/pdfs/internal-migration-in-asia.pdf",
    },
    {
      title: "Regional Consultation On Internal Migration In Asia",
      image:
        "/images/home/reports/Regional_Consultation_on_Internal_Migration_in_Asia-1.jpg",
      link: "/pdfs/regional-consultation-on-internal-migration-in-asia.pdf",
    },
    {
      title: "Ensuring Safe Migration in Asia  Series - Part 1",
      image: "/images/home/reports/Covid_24-july-1.jpg",
      link: "/pdfs/ensuring-safe-migration-in-asia-series-part-1.pdf",
    },
    {
      title: "Ensuring Safe Migration in Asia  Series - Part 2",
      image: "/images/home/reports/Climate-Change_24-july-1.jpg",
      link: "/pdfs/ensuring-safe-migration-in-asia-series-part-2.pdf",
    },
    {
      title: "Ensuring Safe Migration in Asia  Series - Part 3",
      image: "/images/home/reports/Labour-laws_24-july-1.jpg",
      link: "/pdfs/ensuring-safe-migration-in-asia-series-part-3.pdf",
    },
    {
      title: "Ensuring Safe Migration in Asia  Series - Part 4",
      image: "/images/home/reports/Social-Security_24-july-1.jpg",
      link: "/pdfs/ensuring-safe-migration-in-asia-series-part-4.pdf",
    },
  ];
  var responsive = [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 479,
      settings: {
        slidesToShow: 1,
      },
    },
  ];

  return (
    <Section>
      <h2 className="text-blue text-center mb-8">Reports:Trends & Insights</h2>
      <Slick responsive={responsive} autoplay={false}>
        {data?.map((row, key) => (
          <Block data={row} key={"report" + key} />
        ))}
      </Slick>
    </Section>
  );
}
const Block = ({ data }) => {
  const { title, image, link } = data;
  return (
    <div className="flex flex-col items-center w-full h-auto gap-4 md:px-8 px-4">
      <Link
        href={link}
        target={"_blank"}
        className="shrink-0 group flex justify-start items-start relative overflow-hidden lg:h-[30vw] lg:w-[90%] md:h-[45vw] h-[90vw] w-full"
      >
        <Image
          src={image}
          alt={title}
          fill
          className="object-cover object-center w-full"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
        />
      </Link>
      <div className="flex flex-col items-center justify-center w-full h-full gap-2">
        <div
          dangerouslySetInnerHTML={{ __html: title }}
          className="text-darkBlue mb-2 lg:text-[18px] text-base font-medium !text-center lg:min-h-[48px] min-h-[32px]"
        ></div>
        <Link
          href={link}
          target={"_blank"}
          className={cn(
            `mt-auto text-white hover:text-blue bg-blue hover:bg-white border-[1px] border-blue font-medium md:text-[14px] text-sm px-6 py-2 rounded-full capitalize transition-all duration-300 ease w-fit`,
          )}
        >
          Read More
        </Link>
      </div>
    </div>
  );
};
